import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { axiosMaster, axiosSalary } from "../api/axiosInstance";

const AddEditEmployeeTransfer = ({
  editingData,
  selectedEmp,
  onClose,
  onSuccess,
}) => {
  let storedUser = {};

  try {
    storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {}

  const groupId = storedUser?.groupId;
  const userId = storedUser?.userId;

  const [restaurants, setRestaurants] = useState([]);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    id: 0,
    fromRestId: "",
    toRestId: "",
    transferDate: new Date().toISOString().slice(0, 16),
    transferReason: "",
  });

  const fromRef = useRef(null);
  const toRef = useRef(null);
  const dateRef = useRef(null);
  const reasonRef = useRef(null);
  const saveRef = useRef(null);

  useEffect(() => {
    fetchRestaurants();

    const timer = setTimeout(() => {
      fromRef.current?.focus();
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!editingData) return;

    setForm({
      id: editingData.id || 0,
      fromRestId: editingData.fromRestId || "",
      toRestId: editingData.toRestId || "",
      transferDate: editingData.transferDate
        ? editingData.transferDate.slice(0, 16)
        : new Date().toISOString().slice(0, 16),
      transferReason: editingData.transferReason || "",
    });
  }, [editingData]);

  const fetchRestaurants = async () => {
    try {
      const res = await axiosMaster.get(
        `/RestaurantMaster/GetByGroup?groupId=${groupId}`
      );

      setRestaurants(
        (res.data || []).map((r) => ({
          value: r.restId,
          label: r.restaurantName,
        }))
      );
    } catch (err) {
      console.error(err);
      alert("Failed to load restaurants");
    }
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    if (!selectedEmp?.value) {
      alert("Please select employee");
      return;
    }

    if (!form.fromRestId) {
      alert("Select From Restaurant");
      return;
    }

    if (!form.toRestId) {
      alert("Select To Restaurant");
      return;
    }

    if (form.fromRestId === form.toRestId) {
      alert("From and To Restaurant cannot be same");
      return;
    }

    const payload = {
      id: form.id,
      groupId: Number(groupId),
      empId: Number(selectedEmp.value),
      fromRestId: Number(form.fromRestId),
      toRestId: Number(form.toRestId),
      transferDate: new Date(form.transferDate).toISOString(),
      transferReason: form.transferReason,
      userId: Number(userId),
    };

    try {
      setSaving(true);

      await axiosSalary.post(
        "/EmployeeTransferHistory/UpsertTransfer",
        payload
      );

      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error(err);

      alert(
        err?.response?.data?.message ||
          "Failed to save transfer"
      );
    } finally {
      setSaving(false);
    }
  };

  const inputClass =
    "w-full border rounded px-2 py-2 text-sm";

  return (
    <div
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center border-b px-4 py-3">
          <h2 className="font-semibold">
            {editingData ? "Edit Transfer" : "Employee Transfer"}
          </h2>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black"
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-4 space-y-4">

          <div>
            <label className="block text-sm mb-1">
              Employee
            </label>

            <input
              value={selectedEmp?.label || ""}
              disabled
              className={`${inputClass} bg-gray-100`}
            />
          </div>

          <div>
            <label className="block text-sm mb-1">
              From Restaurant
            </label>

            <Select
              ref={fromRef}
              options={restaurants}
              value={
                restaurants.find(
                  (x) => x.value === form.fromRestId
                ) || null
              }
              onChange={(opt) => {
                handleChange(
                  "fromRestId",
                  opt?.value || ""
                );
                toRef.current?.focus();
              }}
            />
          </div>

          <div>
            <label className="block text-sm mb-1">
              To Restaurant
            </label>

            <Select
              ref={toRef}
              options={restaurants}
              value={
                restaurants.find(
                  (x) => x.value === form.toRestId
                ) || null
              }
              onChange={(opt) => {
                handleChange(
                  "toRestId",
                  opt?.value || ""
                );
                dateRef.current?.focus();
              }}
            />
          </div>

          <div>
            <label className="block text-sm mb-1">
              Transfer Date
            </label>

            <input
              ref={dateRef}
              type="datetime-local"
              value={form.transferDate}
              onChange={(e) =>
                handleChange(
                  "transferDate",
                  e.target.value
                )
              }
              className={inputClass}
            />
          </div>

          <div>
            <label className="block text-sm mb-1">
              Transfer Reason
            </label>

            <textarea
              ref={reasonRef}
              rows={3}
              value={form.transferReason}
              onChange={(e) =>
                handleChange(
                  "transferReason",
                  e.target.value
                )
              }
              className={inputClass}
              placeholder="Enter transfer reason"
            />
          </div>

        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-2 border-t px-4 py-3">

          <button
            onClick={onClose}
            className="border px-4 py-2 rounded"
          >
            Cancel
          </button>

          <button
            ref={saveRef}
            onClick={handleSave}
            disabled={saving}
            className="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save"}
          </button>

        </div>
      </div>
    </div>
  );
};

export default AddEditEmployeeTransfer;